import { isXLarge } from "./helpers";

(function ($) {
  "use strict";

  var $shareToggle = $(".js-share-toggle");
  var $shareMenu = $(".js-share-menu");
  var shareMenuOpenClass = "is-open";

  $(document).ready(function () {
    pageUtils();
  });

  function pageUtils() {
    $shareToggle.on("click", function (e) {
      e.preventDefault();

      if ($shareMenu.hasClass(shareMenuOpenClass)) {
        closePageUtilsShare();
      } else {
        openPageUtilsShare();
      }
    });

    $("#page-utilities").show();
  }

  function openPageUtilsShare() {
    $shareMenu.addClass(shareMenuOpenClass);
    // $shareMenu.fadeIn();

    $shareToggle.attr("aria-expanded", "true");

    // close when depressing the Esc key
    $(document).on("keyup.share", function (e) {
      if (e.which == 27) {
        // escape key maps to keycode `27`
        closePageUtilsShare();
      }
    });
  }

  function closePageUtilsShare() {
    // $shareMenu.fadeOut();
    $shareMenu.removeClass(shareMenuOpenClass);
    $shareToggle.attr("aria-expanded", "false");

    // remove the Esc key
    $(document).off(".share");
  }
})(jQuery);

// init the original page utils top offset
let originalPageUtilsOffset = 0;

export function stickPageUtils(
  scrollOffset,
  mainContentOffset,
  pageHeadHeight,
  footerOffset,
  backToTopHeight,
  pageUtilsHeight,
  pageUtilsOffset
) {
  if (!isXLarge()) {
    // Return early for small screens
    $("#page-utilities").css({
      position: "",
      top: "",
    });
    return;
  }

  const FIXED_TOP_OFFSET = 32;

  // set the page utils original offset once the user has scrolled
  if (originalPageUtilsOffset === 0 && pageUtilsOffset > 0) {
    originalPageUtilsOffset = pageUtilsOffset;
  }

  // Calculate the point where the utils should stop being fixed
  const stopPoint =
    footerOffset - (pageHeadHeight + backToTopHeight + pageUtilsHeight);

  // The 200 value compensates for the page utils wrapper
  if (
    originalPageUtilsOffset > 0 &&
    scrollOffset >= originalPageUtilsOffset + 200 &&
    scrollOffset < stopPoint
  ) {
    $("#page-utilities").css({
      position: "fixed",
      top: `${FIXED_TOP_OFFSET}px`,
    });
  } else {
    const topPosition =
      scrollOffset >= stopPoint
        ? stopPoint // When we've scrolled past the stop point
        : mainContentOffset; // When we're at the top

    $("#page-utilities").css({
      position: "absolute",
      top: topPosition,
    });
  }
}
